import { makeStyles, Grid, Paper } from "@material-ui/core";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE4,
} from "App/constants";
import React, { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputOptionMaster,
} from "App/Component/ui";
import { useSelectOption } from "App/hooks";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { urlCreateBarang, urlUpdateBarang } from "../../helpers";
import moment from "moment";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const RESET_STATE_PEMBELIAN_BARANG = {
  pembelian_id: "",
  barang_id: "",
  barang: "",

  satuan_id: "",
  satuan_nama: "",

  satuanjual_id: "",
  satuanjual_nama: "",
  harga: "",
  harga2: "",
  qty: 1,
  subHarga: 0,
  disc: 0,
  nilai_disc: 0,
  tax: 0,
  nilai_tax: 0,
  qjb: 0,
  hargaqjbhpp: 0,
  nobatch: "",
  exired_date: "",
  is_proses: true,
  is_po_proses: false,
  remark: "-",

  // PO
  po_satuan_id: "",
  po_qty: "",
  po_harga_satuan: "",
  po_disc: "",
  po_nilai_disc: "",
};

export const STYLE_WMS_PO = makeStyles({
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "satuan",
    disablePadding: false,
    label: "SATUAN BELI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "qjb",
    disablePadding: false,
    label: "QJB",
    align: "left",
  },
  {
    id: "harga",
    disablePadding: false,
    label: "HARGA BELI",
    align: "left",
    minWidth: "150px",
  },
];

export const ModalBarang = ({
  setShowModal,
  formBarang,
  setFormBarang,
  setNewDataPembelianList,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const satuan = useSelectOption(
    false,
    LIST_URL_WAREHOUSE.masterSatuan.get,
    TYPE_INSTANCE4
  );

  const { formData } = useContext(FormContext);

  const handleChange = (text) => (e) => {
    setFormBarang({
      ...formBarang,
      [text]: e.target.value,
    });
  };

  const create = async () => {
    const api = await instance4.post(urlCreateBarang, {
      pembelian_id: formData.id,
      barang_id: formBarang.barang_id,
      satuan_id: formBarang.satuan_id,
      harga_satuan: parseFloat(convertToValidPrice(formBarang.harga2)),
      qty: parseFloat(convertToValidPrice(formBarang.qty)),
      disc: parseFloat(convertToValidPrice(formBarang.disc)),
      nilai_disc: parseFloat(convertToValidPrice(formBarang.nilai_disc)),
      tax: parseFloat(convertToValidPrice(formBarang.tax)),
      nilai_tax: parseFloat(convertToValidPrice(formBarang.nilai_tax)),
      qjb: parseFloat(convertToValidPrice(formBarang.qjb)),
      hargaqjbhpp: parseFloat(convertToValidPrice(formBarang.hargaqjbhpp)),
      nobatch: formBarang.nobatch,
      exired_date: moment(formBarang.exired_date).format(),
      remark: "-",
    });
    return api;
  };

  const update = async () => {
    const api = await instance4.post(urlUpdateBarang, {
      id: formBarang.id,
      pembelian_id: formData.id,
      barang_id: formBarang.barang_id,
      satuan_id: formBarang.satuan_id,
      harga_satuan: parseFloat(convertToValidPrice(formBarang.harga2)),
      qty: parseFloat(convertToValidPrice(formBarang.qty)),
      disc: parseFloat(convertToValidPrice(formBarang.disc)),
      tax: parseFloat(convertToValidPrice(formBarang.tax)),
      nilai_tax: parseFloat(convertToValidPrice(formBarang.nilai_tax)),
      nilai_disc: parseFloat(convertToValidPrice(formBarang.nilai_disc)),
      qjb: parseFloat(convertToValidPrice(formBarang.qjb)),
      hargaqjbhpp: parseFloat(convertToValidPrice(formBarang.hargaqjbhpp)),
      nobatch: formBarang.nobatch,
      exired_date: moment(formBarang.exired_date).format(),
      remark: "-",
    });
    return api;
  };

  // useEffect(() => {
  //   setFormBarang({
  //     ...formBarang,
  //     harga: convertToValidPrice(formBarang.harga2),
  //   });
  // }, [formBarang.harga2]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (isNull(formBarang.qty)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Banyak tidak boleh kosong");
      return false;
    }else if(isNull(formBarang.qjb)){
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("QJB tidak boleh kosong");
      return false;
    }else if(isNull(formBarang.exired_date)){
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Tanggal EXP (Expired) tidak boleh kosong");
      return false;
    } else {
      try {
        if (formBarang.id === "") {
          const res = await create();
          if (res.data.status === 200) {
            succesCreateOrUpdate("Menambah");
            setNewDataPembelianList(formData.id);
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(res.data.message);
          }
        } else {
          const res = await update();
          if (res.data.status === 200) {
            succesCreateOrUpdate("Mengupdate");
            setNewDataPembelianList(formData.id);
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(res.data.message);
          }
        }
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const succesCreateOrUpdate = (label) => {
    defaultToastSuccess(`Berhasil ${label} Barang`);
    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    setShowModal(false);
  };

  const hitungKeseluruhan = (qty, harga, disc, tax, qjb) => {
    const hargas = convertToValidPrice(harga);
    // const qtys = convertToValidPrice(qty);
    const nilaiDisc = ((convertToValidPrice(disc) / 100) * hargas).toFixed(2);
    const nilaiTax = (
      (convertToValidPrice(tax) / 100) *
      (hargas - nilaiDisc)
    ).toFixed(2);
    const subHarga =
      hargas - convertToValidPrice(nilaiDisc) + convertToValidPrice(nilaiTax);
    const subQjb = (subHarga / convertToValidPrice(qjb)).toFixed(2);
    // const subJumlah = subHarga*qtys;

    setFormBarang({
      ...formBarang,
      harga2: formatRupiah(harga),
      qty: formatRupiah(qty),
      disc: formatRupiah(disc),
      nilai_disc: formatRupiah(parseFloat(nilaiDisc)),
      tax: formatRupiah(tax),
      nilai_tax: formatRupiah(parseFloat(nilaiTax)),
      qjb: formatRupiah(qjb),
      hargaqjbhpp: formatRupiah(parseFloat(subQjb)),
    });
  };

  const useStyles = makeStyles({
    textRed: {
      color: "red",
    },
    border: {
      paddingTop: "10px",
      borderBottom: "1.5px dashed #333333",
    },
  });
  const classes = useStyles();

  return (
    <Modal
      title={`REALISASI PEMBELIAN BARANG`}
      show={setShowModal}
      width="80%"
      offsiteClose={false}
    >
      {formData.id === "" ? (
        <p className="mt-2 mb-2 text-center">
          Silahkan buka transaksi terlebih dahulu
        </p>
      ) : (
        <form action="POST" onSubmit={(e) => handleSubmit(e)}>
          <h4
            className="mb-1"
            style={{
              color: "#828282",
            }}
          >
            {formBarang.barang}
          </h4>

          <div>
            <div
              style={{
                background: "#EAEAEA",
                marginLeft: "-30px",
                marginRight: "-20px",
              }}
            >
              <h5
                style={{
                  padding: "0.5rem 2rem",
                  color: "#828282",
                }}
              >
                DATA PO
              </h5>
            </div>
            <div className="mt-1">
              <Grid container spacing={1}>
                <InputTextMaster
                  type="hidden"
                  name="barang_id"
                  id="barang_id"
                  readOnly={true}
                  value={formBarang.barang_id}
                />
                <Grid item sm={3}>
                  {!formData.is_po ? (
                    <InputTextMaster
                      type="text"
                      name="satuan_id"
                      id="satuan_id"
                      value={"-"}
                      label={"SATUAN BELI"}
                      readOnly={true}
                      disabled={true}
                    />
                  ) : (
                    <InputOptionMaster
                      name="po_satuan_id"
                      label="SATUAN BELI"
                      id="po_satuan_id"
                      withSearch={false}
                      data={satuan}
                      value={formBarang.po_satuan_id}
                      onChange={handleChange("po_satuan_id")}
                      readOnly={true}
                      disabled={true}
                    />
                  )}
                </Grid>
                <Grid item sm={2}>
                  {!formData.is_po ? (
                    <InputTextMaster
                      name="qty"
                      label="BANYAK"
                      id="qty"
                      value="-"
                      disabled={true}
                      readOnly={true}
                      placeholder="Banyak"
                    />
                  ) : (
                    <InputTextMaster
                      name="po_qty"
                      label="BANYAK"
                      id="po_qty"
                      value={formBarang.po_qty}
                      onChange={handleChange("po_qty")}
                      placeholder="Banyak"
                      readOnly={true}
                      disabled={true}
                    />
                  )}
                </Grid>

                <Grid item sm={3}>
                  {!formData.is_po ? (
                    <InputTextMaster
                      name="harga"
                      label="HARGA"
                      id="harga"
                      value="-"
                      readOnly={true}
                      disabled={true}
                    />
                  ) : (
                    <InputTextMaster
                      name="po_harga_satuan"
                      label="HARGA"
                      id="po_harga_satuan"
                      placeholder="0"
                      value={formBarang.po_harga_satuan}
                      readOnly={true}
                      disabled={true}
                    />
                  )}
                </Grid>

                <Grid item sm={2}>
                  {!formData.is_po ? (
                    <InputTextMaster
                      name="disc"
                      label="DISC (%)"
                      id="disc"
                      disabled={true}
                      readOnly={true}
                      value="-"
                    />
                  ) : (
                    <InputTextMaster
                      name="po_disc"
                      label="DISC (%)"
                      id="po_disc"
                      value={formBarang.po_disc}
                      placeholder="%"
                      readOnly={true}
                      disabled={true}
                    />
                  )}
                </Grid>

                <Grid item sm={2}>
                  {!formData.is_po ? (
                    <InputTextMaster
                      name="nilai_disc"
                      label="NILAI DISC"
                      id="nilai_disc"
                      disabled={true}
                      readOnly={true}
                      value="-"
                    />
                  ) : (
                    <InputTextMaster
                      name="po_nilai_disc"
                      label="NILAI DISC"
                      id="po_nilai_disc"
                      value={formBarang.po_nilai_disc}
                      disabled={true}
                      readOnly={true}
                      placeholder="0"
                    />
                  )}
                </Grid>
              </Grid>
            </div>
          </div>

          <div
            style={{
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                background: "#EAEAEA",
                marginLeft: "-30px",
                marginRight: "-20px",
              }}
            >
              <h5
                style={{
                  padding: "0.5rem 2rem",
                  color: "#828282",
                }}
              >
                DATA PEMBELIAN
              </h5>
            </div>

            <div className="mt-1">
              <Grid container spacing={1}>
                <Grid item xs={12} md={6}>
                  <Grid container spacing={1}>
                    <InputTextMaster
                      type="hidden"
                      name="barang_id"
                      id="barang_id"
                      readOnly={true}
                      value={formBarang.barang_id}
                    />
                    <Grid item sm={4}>
                      <InputOptionMaster
                        name="satuan_id"
                        label="SATUAN BELI"
                        id="satuan_id"
                        withSearch={true}
                        data={satuan}
                        value={formBarang.satuan_id}
                        labelValue={
                          isNull(formBarang.satuan_nama)
                            ? "Pilih Satuan Beli"
                            : formBarang.satuan_nama
                        }
                        onChange={(e) => {
                          if (isNull(e)) {
                            setFormBarang({
                              ...formBarang,
                              satuan_id: "",
                              satuan_nama: "",
                            });
                          } else {
                            setFormBarang({
                              ...formBarang,
                              satuan_id: e.value,
                              satuan_nama: e.label,
                            });
                          }
                          handleChange("satuan_id");
                        }}
                      />
                    </Grid>

                    <Grid item sm={12} md={4}>
                      <InputTextMaster
                        name="qty"
                        label="BANYAK"
                        id="qty"
                        value={formBarang.qty}
                        onChange={(e) => {
                          let val = e.target.value;
                          if (!isNull(val)) {
                            hitungKeseluruhan(
                              val,
                              formBarang.harga2,
                              formBarang.disc,
                              formBarang.tax,
                              formBarang.qjb
                            );

                            // setFormBarang({
                            //   ...formBarang,
                            //   qty: formatRupiah(val),
                            // });
                          } else {
                            setFormBarang({
                              ...formBarang,
                              qty: val,
                            });
                          }
                        }}
                        placeholder="Banyak"
                        withButton={true}
                      >
                        <button
                          type={"button"}
                          onClick={null}
                          style={{
                            borderRight: "1px solid #EAEAEA",
                            borderTop: "1px solid #EAEAEA",
                            borderBottom: "1px solid #EAEAEA",
                            borderLeft: "0",
                            background: "#fff",
                            padding: "0 0.8rem",
                            cursor: "pointer",
                            borderRadius: "0 6px 6px 0",
                          }}
                        >
                          {formBarang.satuan_nama}
                        </button>
                      </InputTextMaster>
                    </Grid>
                    <Grid item sm={12} md={4}>
                      <InputTextMaster
                        name="harga"
                        label="HARGA SATUAN BELI"
                        id="harga"
                        placeholder="0"
                        value={formBarang.harga2}
                        onInput={(e) => {
                          let val = e.target.value;
                          hitungKeseluruhan(
                            formBarang.qty,
                            val,
                            formBarang.disc,
                            formBarang.tax,
                            formBarang.qjb
                          );
                          // setFormBarang({
                          //   ...formBarang,
                          //   harga2: formatRupiah(val),
                          //   hargaqjbhpp: convertToValidPrice(val) / formBarang.qjb,
                          // });
                        }}
                        withButtonLeft={true}
                      >
                        <button
                          type={"button"}
                          onClick={null}
                          style={{
                            borderLeft: "1px solid #EAEAEA",
                            borderTop: "1px solid #EAEAEA",
                            borderBottom: "1px solid #EAEAEA",
                            borderRight: "0",
                            background: "#fff",
                            padding: "0 0 0 0.8rem",
                            cursor: "pointer",
                            borderRadius: "6px 0 0 6px",
                            fontSize: "10px",
                          }}
                        >
                          Rp.
                        </button>
                      </InputTextMaster>
                    </Grid>

                    <Grid item sm={12} md={6}>
                      <InputTextMaster
                        name="disc"
                        label="DISC (%)"
                        id="disc"
                        value={formBarang.disc}
                        onChange={(e) => {
                          let val = e.target.value;
                          hitungKeseluruhan(
                            formBarang.qty,
                            formBarang.harga2,
                            val,
                            formBarang.tax,
                            formBarang.qjb
                          );
                        }}
                        placeholder="0"
                        withButton={true}
                      >
                        <button
                          type={"button"}
                          onClick={null}
                          style={{
                            borderRight: "1px solid #EAEAEA",
                            borderTop: "1px solid #EAEAEA",
                            borderBottom: "1px solid #EAEAEA",
                            borderLeft: "0",
                            background: "#fff",
                            padding: "0 0.8rem",
                            cursor: "pointer",
                            borderRadius: "0 6px 6px 0",
                          }}
                        >
                          %
                        </button>
                      </InputTextMaster>
                    </Grid>
                    <Grid item sm={12} md={6}>
                      <InputTextMaster
                        name="tax"
                        label="TAX (%)"
                        id="tax"
                        value={formBarang.tax}
                        onChange={(e) => {
                          let val = e.target.value;
                          hitungKeseluruhan(
                            formBarang.qty,
                            formBarang.harga2,
                            formBarang.disc,
                            val,
                            formBarang.qjb
                          );
                        }}
                        placeholder="0"
                        withButton={true}
                      >
                        <button
                          type={"button"}
                          onClick={null}
                          style={{
                            borderRight: "1px solid #EAEAEA",
                            borderTop: "1px solid #EAEAEA",
                            borderBottom: "1px solid #EAEAEA",
                            borderLeft: "0",
                            background: "#fff",
                            padding: "0 0.8rem",
                            cursor: "pointer",
                            borderRadius: "0 6px 6px 0",
                          }}
                        >
                          %
                        </button>
                      </InputTextMaster>
                    </Grid>

                    <Grid item sm={12} md={6}>
                      <InputOptionMaster
                        name="satuanjual_id"
                        label="SATUAN JUAL"
                        id="satuanjual_id"
                        withSearch={false}
                        data={satuan}
                        value={formBarang.satuanjual_id}
                        disabled={true}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item sm={12} md={6}>
                      <InputTextMaster
                        name="qjb"
                        label="QJB"
                        id="qjb"
                        value={formBarang.qjb}
                        onChange={(e) => {
                          let val = e.target.value;

                          hitungKeseluruhan(
                            formBarang.qty,
                            formBarang.harga2,
                            formBarang.disc,
                            formBarang.tax,
                            val
                          );
                        }}
                        placeholder="Qjb"
                        withButton={true}
                      >
                        <button
                          type={"button"}
                          onClick={null}
                          style={{
                            borderRight: "1px solid #EAEAEA",
                            borderTop: "1px solid #EAEAEA",
                            borderBottom: "1px solid #EAEAEA",
                            borderLeft: "0",
                            background: "#fff",
                            padding: "0 0.8rem",
                            cursor: "pointer",
                            borderRadius: "0 6px 6px 0",
                          }}
                        >
                          {formBarang.satuanjual_nama}
                        </button>
                      </InputTextMaster>
                    </Grid>
                    <Grid item sm={12} md={6}>
                      <InputTextMaster
                        name="nobatch"
                        label="NO BATCH"
                        id="nobatch"
                        value={formBarang.nobatch}
                        onChange={handleChange("nobatch")}
                        placeholder="No. Batch"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <InputTextMaster
                        name="exired_date"
                        label="EXP"
                        id="exired_date"
                        value={formBarang.exired_date}
                        onChange={handleChange("exired_date")}
                        placeholder="Expired Date"
                        type={"date"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper className="p-1">
                    <div>
                      <table
                        width="100%"
                        className="table-perhitungan-pembelian-wms"
                      >
                        <tbody>
                          <tr>
                            <td width="40%">Harga Beli Satuan</td>
                            <td width="5%">:</td>
                            <td width="5%">Rp. </td>
                            <td width="50%" align="right">
                              {isNull(formBarang.harga2)
                                ? 0
                                : formBarang.harga2}
                            </td>
                          </tr>
                          <tr>
                            <td width="40%" className={`${classes.textRed}`}>
                              Sub Disc ({isNull(formBarang.disc) ? 0 : formBarang.disc}%)
                            </td>
                            <td width="5%">:</td>
                            <td width="5%" className={`${classes.textRed}`}>
                              Rp.{" "}
                            </td>
                            <td
                              width="50%"
                              align="right"
                              className={`${classes.textRed}`}
                            >
                              {isNull(formBarang.nilai_disc)
                                ? 0
                                : formBarang.nilai_disc}
                            </td>
                          </tr>

                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="2" className={classes.border}></td>
                          </tr>

                          <tr>
                            <td width="40%">Jumlah</td>
                            <td width="5%">:</td>
                            <td width="5%">Rp. </td>
                            <td width="50%" align="right">
                              {formatNumber(
                                convertToValidPrice(formBarang.harga2) -
                                  convertToValidPrice(formBarang.nilai_disc)
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td width="40%" className={`${classes.textRed}`}>
                              Tax ({isNull(formBarang.tax) ? 0 : formBarang.tax}
                              %)
                            </td>
                            <td width="5%">:</td>
                            <td width="5%" className={`${classes.textRed}`}>
                              Rp.{" "}
                            </td>
                            <td
                              width="50%"
                              align="right"
                              className={`${classes.textRed}`}
                            >
                              {isNull(formBarang.nilai_tax)
                                ? 0
                                : formBarang.nilai_tax}
                            </td>
                          </tr>

                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="2" className={classes.border}></td>
                          </tr>

                          <tr>
                            <td width="40%">Sub Total</td>
                            <td width="5%">:</td>
                            <td width="5%">Rp. </td>
                            <td width="50%" align="right">
                              {formatNumber(
                                convertToValidPrice(formBarang.harga2) -
                                  convertToValidPrice(formBarang.nilai_disc) +
                                  convertToValidPrice(formBarang.nilai_tax)
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td width="40%">QTY</td>
                            <td width="5%">:</td>
                            <td width="5%"></td>
                            <td width="50%" align="right">
                              {formBarang.qty}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="2" className={classes.border}></td>
                          </tr>

                          <tr>
                            <td width="40%">
                              <b>Total</b>
                            </td>
                            <td width="5%">
                              <b>:</b>
                            </td>
                            <td width="5%">
                              <b>Rp. </b>
                            </td>
                            <td width="50%" align="right">
                              <b>
                                {formatNumber(
                                  (convertToValidPrice(formBarang.harga2) -
                                    convertToValidPrice(formBarang.nilai_disc) +
                                    convertToValidPrice(formBarang.nilai_tax)) *
                                    convertToValidPrice(formBarang.qty)
                                )}
                              </b>
                            </td>
                          </tr>
                          <tr>
                            <td width="40%">QJB</td>
                            <td width="5%">:</td>
                            <td width="5%"></td>
                            <td width="50%" align="right">
                              {formatNumber(convertToValidPrice(formBarang.qjb))}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="2" className={classes.border}></td>
                          </tr>
                          <tr>
                            <td width="40%">
                              <b>HARGA QJB / HPP</b>
                            </td>
                            <td width="5%">
                              <b>:</b>
                            </td>
                            <td width="5%">
                              <b>Rp. </b>
                            </td>
                            <td width="50%" align="right">
                              <b>{formBarang.hargaqjbhpp}</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Paper>
                </Grid>
              </Grid>
            </div>
          </div>

          <div>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <MasterButton
                className={"mt-1"}
                type="submit"
                color={disabled.color}
                name={disabled.label}
                disabled={disabled.state}
                size="md"
              />
            </Grid>
          </div>
        </form>
      )}
    </Modal>
  );
};
